import React from "react";

// Renders reading/interpretation text as readable prose: clean sans body,
// generous line-height, and proper paragraph spacing. Optional streaming cursor.
export const ReadingText = ({ text, streaming = false, className = "", testId }) => {
  const paragraphs = (text || "").split(/\n{2,}/);
  return (
    <div className={`reading-prose ${className}`} data-testid={testId}>
      {paragraphs.map((p, i) => (
        <p key={i}>
          {p}
          {streaming && i === paragraphs.length - 1 && <span className="reading-cursor" />}
        </p>
      ))}
    </div>
  );
};
